import * as utilTypes from '../types/Util';
import * as errorActions from './Error';
import {UTIL_ERROR} from '../const/ErrorPlace';
import {handleError} from './ErrorHandler';
import * as apiCalls from '../api/ApiCalls';



export function getComplaintsTypesDictionary() {
    return async (dispatch, getState) => {
        dispatch(getComplaintsTypesDictionaryRequest());
        try {
            let customerType = getState().customer.type;
            const response = await apiCalls.GetComplaintsTypes(customerType.id);
            const complaintTypes = await response.json();
            dispatch(getComplaintsTypesDictionarySuccess(complaintTypes));
        } catch (error) {
            handleError(dispatch, error, utilTypes.GET_COMPLAINTS_TYPES_DICTIONARY_FAILURE);
        }
    };
} 

export function getComplaintsTypesDictionaryFailure(error) {
    return {
        type: utilTypes.GET_COMPLAINTS_TYPES_DICTIONARY_FAILURE,
        payload: error
    };
}

export function getComplaintsTypesDictionaryRequest() {
    return {
        type: utilTypes.GET_COMPLAINTS_TYPES_DICTIONARY_REQUEST
    };
}

export function getComplaintsTypesDictionarySuccess(complaintTypes) {
    return {
        type: utilTypes.GET_COMPLAINTS_TYPES_DICTIONARY_SUCCESS,
        payload: complaintTypes
    };
}
export function getCustomersTypesDictionary() {
    return async (dispatch) => {
        dispatch(getCustomersTypesDictionaryRequest());
        try {
            const response = await apiCalls.GetCustomerTypes();
            const customerTypes = await response.json();
            dispatch(getCustomersTypesDictionarySuccess(customerTypes));
        } catch (error) {
            handleError(dispatch, error, utilTypes.GET_CUSTOMERS_TYPES_DICTIONARY_FAILURE);
        }
    };
} 

export function getCustomersTypesDictionaryFailure(error) {
    return {
        type: utilTypes.GET_CUSTOMERS_TYPES_DICTIONARY_FAILURE,
        payload: error
    };
}

export function getCustomersTypesDictionaryRequest() {
    return {
        type: utilTypes.GET_CUSTOMERS_TYPES_DICTIONARY_REQUEST
    };
}

export function getCustomersTypesDictionarySuccess(customerTypes) {
    return {
        type: utilTypes.GET_CUSTOMERS_TYPES_DICTIONARY_SUCCESS,
        payload: customerTypes
    };
}

export function getQuantityCorrectionsProposalsDictionary() {
    return async (dispatch) => {
        dispatch(getQuantityCorrectionsProposalsDictionaryRequest());
        try {
            const response = await apiCalls.GetQuantityCorrectionsProposals();
            const quantityCorrectionsProposals = await response.json();
            dispatch(getQuantityCorrectionsProposalsDictionarySuccess(quantityCorrectionsProposals));
        } catch (error) {
            handleError(dispatch, error, utilTypes.GET_QUANTITY_CORRECTIONS_PROPOSALS_DICTIONARY_FAILURE);
        }
    };
} 

export function getQuantityCorrectionsProposalsDictionaryFailure(error) {
    return {
        type: utilTypes.GET_QUANTITY_CORRECTIONS_PROPOSALS_DICTIONARY_FAILURE,
        payload: error
    };
}

export function getQuantityCorrectionsProposalsDictionaryRequest() {
    return {
        type: utilTypes.GET_QUANTITY_CORRECTIONS_PROPOSALS_DICTIONARY_REQUEST
    };
}

export function getQuantityCorrectionsProposalsDictionarySuccess(quantityCorrectionsProposals) {
    return {
        type: utilTypes.GET_QUANTITY_CORRECTIONS_PROPOSALS_DICTIONARY_SUCCESS,
        payload: quantityCorrectionsProposals
    };
}


export function getTermOfUseURL() {
    return async (dispatch) => {
        dispatch(getTermOfUseURLRequest());
        try {
            const response = await apiCalls.GetTermOfUseURL();
            const result = await response.json();
            if(response.status===200) {
                return dispatch(getTermOfUseURLSuccess(result));
            }
            else{
                return dispatch(errorActions.throwErrorByPlace(UTIL_ERROR, {
                    errorTitle: "Błąd pobierania danych",
                    errorMessage: result.exceptionMessage
                }));
            }
            
        } catch (error) {
            handleError(dispatch, error, utilTypes.GET_TERM_OF_USE_URL_FAILURE);
        }
    };
} 

export function getTermOfUseURLFailure(error) {
    return {
        type: utilTypes.GET_TERM_OF_USE_URL_FAILURE,
        payload: error
    };
}

export function getTermOfUseURLRequest() {
    return {
        type: utilTypes.GET_TERM_OF_USE_URL_REQUEST
    };
}

export function getTermOfUseURLSuccess(termOfUseURL) {
    return {
        type: utilTypes.GET_TERM_OF_USE_URL_SUCCESS,
        payload: termOfUseURL
    };
}

export function getAllowMultiplePositionsForComplaintSetting() {
    return async (dispatch) => {
        dispatch(getAllowMultiplePositionsForComplaintSettingRequest());
        try {
            const response = await apiCalls.GetAllowMultiplePositionsForComplaintSetting();
            const result = await response.json();
            if(response.status===200) {
                return dispatch(getAllowMultiplePositionsForComplaintSettingSuccess(result));
            }
            else{
                return dispatch(errorActions.throwErrorByPlace(UTIL_ERROR, {
                    errorTitle: "Błąd pobierania danych",
                    errorMessage: result.exceptionMessage
                }));
            }
            
        } catch (error) {
            handleError(dispatch, error, utilTypes.GET_ALLOW_MULTIPLE_COMPLAINT_POSITION_FAILURE);
        }
    };
}

export function getAllowMultiplePositionsForComplaintSettingFailure(error) {
    return {
        type: utilTypes.GET_ALLOW_MULTIPLE_COMPLAINT_POSITION_FAILURE,
        payload: error
    };
}

export function getAllowMultiplePositionsForComplaintSettingRequest() {
    return {
        type: utilTypes.GET_ALLOW_MULTIPLE_COMPLAINT_POSITION_REQUEST
    };
}

export function getAllowMultiplePositionsForComplaintSettingSuccess(allowMultiplePositionsForComplaint) {
    return {
        type: utilTypes.GET_ALLOW_MULTIPLE_COMPLAINT_POSITION_SUCCESS,
        payload: allowMultiplePositionsForComplaint
    };
}

export function getIsMyCompanyNotFoundCheckBoxVisibleSetting() {
    return async (dispatch) => {
        dispatch(getIsMyCompanyNotFoundCheckBoxVisibleSettingRequest());
        try {
            const response = await apiCalls.GetIsMyCompanyNotFoundCheckBoxVisibleSetting();
            const result = await response.json();
            if(response.status===200) {
                return dispatch(getIsMyCompanyNotFoundCheckBoxVisibleSettingSuccess(result));
            }
            else{
                return dispatch(errorActions.throwErrorByPlace(UTIL_ERROR, {
                    errorTitle: "Błąd pobierania danych",
                    errorMessage: result.exceptionMessage
                }));
            }
            
        } catch (error) {
            handleError(dispatch, error, utilTypes.GET_IS_MY_COMPANY_NOT_FOUND_CHECKBOX_VISIBLE_FAILURE);
        }
    };
}

export function getIsMyCompanyNotFoundCheckBoxVisibleSettingFailure(error) {
    return {
        type: utilTypes.GET_IS_MY_COMPANY_NOT_FOUND_CHECKBOX_VISIBLE_FAILURE,
        payload: error
    };
}

export function getIsMyCompanyNotFoundCheckBoxVisibleSettingRequest() {
    return {
        type: utilTypes.GET_IS_MY_COMPANY_NOT_FOUND_CHECKBOX_VISIBLE_REQUEST
    };
}

export function getIsMyCompanyNotFoundCheckBoxVisibleSettingSuccess(isMyCompanyNotFoundCheckBoxVisible) {
    return {
        type: utilTypes.GET_IS_MY_COMPANY_NOT_FOUND_CHECKBOX_VISIBLE_SUCCESS,
        payload: isMyCompanyNotFoundCheckBoxVisible
    };
}

export function getIsSerialNumberTooltipVisibleSetting() {
    return async (dispatch) => {
        dispatch(getIsSerialNumberTooltipVisibleRequest());
        try {
            const response = await apiCalls.GetIsSerialNumberTooltipVisibleSetting();
            const result = await response.json();
            if(response.status===200) {
                return dispatch(getIsSerialNumberTooltipVisibleSuccess(result));
            }
            else{
                return dispatch(errorActions.throwErrorByPlace(UTIL_ERROR, {
                    errorTitle: "Błąd pobierania danych",
                    errorMessage: result.exceptionMessage
                }));
            }
            
        } catch (error) {
            handleError(dispatch, error, utilTypes.GET_IS_SERIAL_NUMBER_TOOLTIP_VISIBLE_FAILURE);
        }
    };
}

export function getIsSerialNumberTooltipVisibleFailure(error) {
    return {
        type: utilTypes.GET_IS_MY_COMPANY_NOT_FOUND_CHECKBOX_VISIBLE_FAILURE,
        payload: error
    };
}

export function getIsSerialNumberTooltipVisibleRequest() {
    return {
        type: utilTypes.GET_IS_SERIAL_NUMBER_TOOLTIP_VISIBLE_REQUEST
    };
}

export function getIsSerialNumberTooltipVisibleSuccess(isSerialNumberTooltipVisible) {
    return {
        type: utilTypes.GET_IS_SERIAL_NUMBER_TOOLTIP_VISIBLE_SUCCESS,
        payload: isSerialNumberTooltipVisible
    };
}


export function getCouriers() {
    return async (dispatch) => {
        dispatch(getCouriersRequest());
        try {
            const response = await apiCalls.GetCouriers();
            const result = await response.json();
            if(response.status===200) {
                return dispatch(getCouriersSuccess(result));
            }
            else{
                return dispatch(errorActions.throwErrorByPlace(UTIL_ERROR, {
                    errorTitle: "Błąd pobierania danych",
                    errorMessage: result.exceptionMessage
                }));
            }
            
        } catch (error) {
            handleError(dispatch, error, utilTypes.GET_TERM_OF_USE_URL_FAILURE);
        }
    };
} 

export function getCouriersFailure(error) {
    return {
        type: utilTypes.GET_COURIERS_FAILURE,
        payload: error
    };
}

export function getCouriersRequest() {
    return {
        type: utilTypes.GET_COURIERS_REQUEST
    };
}

export function getCouriersSuccess(couriers) {
    return {
        type: utilTypes.GET_COURIERS_SUCCESS,
        payload: couriers
    };
}




// WEBPACK FOOTER //
// ./src/actions/Util.js